import * as React from "react";
import { Alert, Box, Snackbar } from "@mui/material";
import { MobileModal } from "../MobileModal";
import { LoadingButton } from "@mui/lab";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Input } from "../Input";
import { height } from "@mui/system";
import { describe } from "../../services/salesforce";
import { post } from "../../api";
import { useState } from "react";

const SelfTourWaitlist = ({ open, onClose, listing = {}, onComplete }) => {
    const [saveLoading, setSaveLoading] = React.useState(false);
    const firstNameRef = React.useRef();
    const lastNameRef = React.useRef();
    const emailRef = React.useRef();
    const phoneRef = React.useRef();
    const moveInDateRef = React.useRef();
    const [details, setDetails] = React.useState({ moveInDate: "" });
    const [moveInList, setMoveInList] = React.useState([]);

    const refs = [firstNameRef, lastNameRef, emailRef, phoneRef, moveInDateRef];

    React.useEffect(() => {
        getLeadDescribe();
    }, []);

    const getLeadDescribe = async () => {
        const result = await describe("lead", { cacheable: true });
        if (result.isSuccess) {
            for (let field of result?.data?.fields) {
                if (field.name === "What_is_your_timeframe_to_move_in__c") {
                    setMoveInList(field.picklistValues);
                }
            }
        }
    };
    const validate = () => {
        let hasError = false;
        for (let i = 0; i < refs.length; i++) {
            if (!refs[i].current.validate()) {
                hasError = true;
            }
        }
        return !hasError;
    };

    const getCookie = (cookieName) => {
        // Split cookies string into individual cookies
        var cookies = document.cookie.split(";");

        // Loop through each cookie
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();

            // Check if this cookie is the one we're looking for
            if (cookie.indexOf(cookieName + "=") === 0) {
                // Extract and return the cookie value
                return cookie.substring(cookieName.length + 1);
            }
        }

        // If the cookie is not found, return null
        return null;
    };

    const handleSaveClick = () => {
        if (validate()) {
            setSaveLoading(true);
            debugger;
            let record = { ...details };
            record.listingId = listing.salesforceId;

            let adParams = getCookie("adParams");
            if (adParams) {
                let paramValues = new URLSearchParams(adParams);

                let utmParameters = {};
                if (paramValues.get("utm_source")) {
                    utmParameters["utm_source"] = paramValues.get("utm_source");
                }
                if (paramValues.get("utm_medium")) {
                    utmParameters["utm_medium"] = paramValues.get("utm_medium");
                }
                if (paramValues.get("utm_campaign")) {
                    utmParameters["utm_campaign"] = paramValues.get("utm_campaign");
                }
                if (paramValues.get("utm_content")) {
                    utmParameters["utm_content"] = paramValues.get("utm_content");
                }
                if (paramValues.get("utm_term")) {
                    utmParameters["utm_term"] = paramValues.get("utm_term");
                }
                if (Object.keys(utmParameters).length > 0) {
                    record.utmParameters = JSON.stringify(utmParameters);
                }
            }

            post(`lead/createFormEntry`, record).then(async (result) => {
                if (result.isSuccess && result.data) {
                    setSaveLoading(false);
                    handleCancelClick();
                    onComplete(true);
                } else {
                    onComplete(false);
                    setSaveLoading(false);
                }
            });
        }
    };
    const handleCancelClick = () => {
        setDetails({ moveInDate: "" });
        onClose();
    };

    const getMoveInTimeOption = () => {
        return moveInList;
    };

    const handleChange = (key, value) => {
        let data = { ...details };
        data[key] = value;

        setDetails(data);
    };

    return (
        <MobileModal
            title="Join Self-Tour Waitlist"
            open={open}
            displayTopBorder={true}
            onClose={() => {
                onClose();
            }}>
            <Box sx={{ mb: "3rem" }}>
                <Box sx={{ fontSize: "12px", color: "#164C63", textAlign: "center", mt: "10px" }}>
                    Thank you for your interest in <b>{listing.propertyAddress}</b>. Be the first to tour this home!
                    Join the waitlist below, and we’ll notify you as soon as tours open.
                </Box>
                <Box sx={{ mt: "10px" }}>
                    <Input
                        id="firstName"
                        label="First Name"
                        name="firstName"
                        margin="normal"
                        isRequired={true}
                        value={details.firstName}
                        labelFontSize="14px"
                        labelColor="#3F3F46"
                        ref={firstNameRef}
                        autoFocus
                        fullWidth
                        autoComplete="off"
                        sx={{ height: "32px" }}
                        onChange={(value) => handleChange("firstName", value)}
                    />
                    <Input
                        id="lastName"
                        label="Last Name"
                        name="lastName"
                        margin="normal"
                        isRequired={true}
                        value={details.lastName}
                        labelFontSize="14px"
                        labelColor="#3F3F46"
                        ref={lastNameRef}
                        autoFocus
                        fullWidth
                        autoComplete="off"
                        sx={{ height: "32px" }}
                        onChange={(value) => handleChange("lastName", value)}
                    />
                    <Input
                        id="email"
                        label="Email Address"
                        name="email"
                        type="email"
                        margin="normal"
                        isRequired={true}
                        value={details.email}
                        labelFontSize="14px"
                        labelColor="#3F3F46"
                        ref={emailRef}
                        autoFocus
                        fullWidth
                        autoComplete="off"
                        sx={{ height: "32px" }}
                        onChange={(value) => handleChange("email", value)}
                    />
                    <Input
                        id="phone"
                        type="maskType"
                        margin="normal"
                        ref={phoneRef}
                        labelFontSize="14px"
                        labelColor="#3F3F46"
                        label={"Phone Number"}
                        value={details.phone}
                        autoComplete="off"
                        onChange={(value) => handleChange("phone", value)}
                        mask={"(999) 999-9999"}
                        isRequired={true}></Input>

                    <Input
                        id="moveInDate"
                        type="select"
                        margin="normal"
                        displayEmpty={true}
                        labelFontSize="14px"
                        labelColor="#3F3F46"
                        ref={moveInDateRef}
                        label={"How soon are you looking to move?"}
                        options={getMoveInTimeOption()}
                        value={details.moveInDate}
                        autoComplete="off"
                        onChange={(value) => handleChange("moveInDate", value)}
                        isRequired={true}></Input>

                    <Box sx={{ mt: "10px", fontSize: "12px", color: "#475467", textAlign: "center" }}>
                        By entering a phone number and submitting this form, I authorize Pathway Homes and its service
                        providers to contact me at the number I provide via voice call, text, artificial prerecorded
                        voice, and ringless voicemail using an automatic telephone dialing system for marketing
                        purposes.  Not a condition for purchase. Message and data rates may apply. To opt-out at any
                        time reply "STOP" or revoke your consent over phone
                    </Box>
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        background: "white",
                        padding: "8px 8px 8px 8px",
                        width: "100%",
                        borderTop: "1px solid gainsboro",
                    }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
                        <Box sx={{ width: "50%" }}>
                            <LoadingButton
                                variant="outlined"
                                color="primary"
                                fullWidth
                                sx={{
                                    textTransform: "none",
                                    borderRadius: "50px",
                                    borderColor: "#D1D1D6",
                                    color: "#3F3F46",
                                    height: "100%",
                                }}
                                onClick={handleCancelClick}>
                                Cancel
                            </LoadingButton>
                        </Box>
                        <Box sx={{ width: "50%" }}>
                            <LoadingButton
                                size="small"
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{
                                    textTransform: "none",
                                    borderRadius: "50px",
                                    backgroundColor: "#06AED4",
                                    height: "100%",
                                }}
                                loading={saveLoading}
                                onClick={handleSaveClick}>
                                Submit
                            </LoadingButton>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </MobileModal>
    );
};

export { SelfTourWaitlist };
